export default "__VITE_ASSET__QEyiv0bY__"